import { CONTACT_US_URL } from 'config/constants';
import { getAreAgentsAvailable, launchChatWindow } from '../liveChat';

const openLiveChat = () => {
  const returnValue = { liveChatAvailable: false };
  const areAgentsAvailable = getAreAgentsAvailable();

  if (areAgentsAvailable) {
    returnValue.liveChatAvailable = true;
    launchChatWindow();
  } else {
    window.open(CONTACT_US_URL, '_blank');
  }

  return returnValue;
};

export default openLiveChat;
